import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getCourseResources } from '../api';
import Course from '../types/Course';
import CourseResource from '../types/CourseResource';

import CourseResourcesList from './CourseResourcesList';

const CourseResourcesModal: React.FC<{
  course?: Course;
  onClose: () => void;
}> = ({ course, onClose }) => {
  const [resources, setResources] = useState<CourseResource[]>();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    if (!course) return;
    getCourseResources(course.id)
      .then(({ data }) => setResources(data))
      .finally(() => setLoading(false));
  }, [course]);

  return (
    <Modal
      open={!!course}
      onCancel={onClose}
      footer={null}
      title={t('components.CourseResourcesModal.title', {
        courseName: course?.name,
      })}>
      <CourseResourcesList
        loadingCourseResources={loading}
        courseResources={resources}
      />
    </Modal>
  );
};

export default CourseResourcesModal;
